import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 2.932h-8.5L8.8.39C8.6.195 8.3 0 8 0H3C1.3 0 0 1.27 0 2.932v13.686c0 1.662 1.3 2.933 3 2.933h16c1.7 0 3-1.271 3-2.933V5.865c0-1.662-1.3-2.933-3-2.933m1 13.686c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978V2.932c0-.587.4-.978 1-.978h4.5l1.7 2.542c.2.196.5.391.8.391h9c.6 0 1 .391 1 .978z"
    }, null, -1)
  ]))]))
}
export default { render: render }